import {useQuizContext} from "@/pages/quiz/context";

const useGetGender = () => {
    const { answers } = useQuizContext();

    const genderAnswer = Object.values(answers).find(
        (a) => a?.blockName === "select-sex"
    ) as { value?: string };

    const value = genderAnswer?.value;

  return {
    isFemale: value === 'female',
    isMale: value === 'male'
  };
};

export { useGetGender };
